import {
    FaFacebookF,
    FaInstagram,
    FaYoutube,
    FaWhatsapp,
    FaLinkedinIn,
  } from "react-icons/fa";
  
  const Footer = () => (
    <footer className="bg-green-50 border-t border-green-100 py-8 text-sm text-gray-700">
      <div className="max-w-6xl mx-auto px-4 flex flex-col md:flex-row items-center justify-between gap-4">
        {/* Social Icons */}
        <div className="flex gap-4 text-green-800 text-xl">
          <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="hover:text-indigo-600 transition">
            <FaFacebookF />
          </a>
          <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="hover:text-indigo-600 transition">
            <FaInstagram />
          </a>
          <a href="https://youtube.com" target="_blank" rel="noopener noreferrer" className="hover:text-indigo-600 transition">
            <FaYoutube />
          </a>
          <a href="https://wa.me/919999999999" target="_blank" rel="noopener noreferrer" className="hover:text-indigo-600 transition">
            <FaWhatsapp />
          </a>
          <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" className="hover:text-indigo-600 transition">
            <FaLinkedinIn />
          </a>
        </div>
  
        {/* Copyright */}
        <p className="text-center md:text-right">
          © {new Date().getFullYear()} ShreeNirmala. All rights reserved.
        </p>
      </div>
    </footer>
  );
  
  export default Footer;
  